import { formatDate } from './formatDate';

export function getFullDate(date) {
  return formatDate(date);
}
